import { Box, Flex, Icon, SimpleGrid, Text } from '@chakra-ui/react';
import { FiChevronRight } from 'react-icons/fi';

// As seis etapas do ciclo de Data Literacy que ficavam na página inicial do
// módulo, agora em formato compacto.
const STEPS = [
  'Visão e planejamento',
  'Comunicação',
  'Média força de trabalho',
  'Cultura e aprendizado',
  'Aprendizado prescritivo',
  'Mensurar',
];

export function DataLiteracyCycle() {
  return (
    <Box
      bg="gray.800"
      borderWidth="1px"
      borderColor="gray.700"
      borderRadius="12px"
      p="4"
    >
      <Text fontWeight="bold" color="blue.500" fontSize="lg">
        Data Literacy
      </Text>
      <Text fontSize="sm" color="gray.500" mb="4">
        O ciclo que orienta o uso dos dados na COOASGO.
      </Text>

      <SimpleGrid columns={{ base: 1, sm: 2, md: 3, xl: 6 }} spacing="3">
        {STEPS.map((step, index) => (
          <Flex key={step} align="center" gridGap="2">
            <Flex
              w="7"
              h="7"
              flexShrink={0}
              borderRadius="full"
              bg="blue.500"
              color="white"
              fontSize="sm"
              fontWeight="bold"
              align="center"
              justify="center"
            >
              {index + 1}
            </Flex>
            <Text fontSize="sm" color="gray.50" flex="1">
              {step}
            </Text>
            {index < STEPS.length - 1 && (
              <Icon
                as={FiChevronRight}
                color="gray.500"
                display={{ base: 'none', xl: 'block' }}
              />
            )}
          </Flex>
        ))}
      </SimpleGrid>
    </Box>
  );
}
